export enum Collections {
    'Wooden pen' = 1,
    'Ballpoint pencil' = 2,
    'Feather pencil' = 3
}